<template>
    <section class="login py-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 mx-auto">
                    <img src="@/assets/images/ITA_Airways_Logo.svg" class="login-logo m-auto d-block" alt="" />
                    <h5 class="text-center mt-5">Quality observer</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mx-auto">
                    <div v-if="tokenError" class="alert alert-danger mt-3 text-center">
                        Token di accesso scaduto.
                    </div>
                    <button @click="navigateToLogin" class="btn btn-block btn-success">
                        VAI ALLA LOGIN
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import {
    mapGetters
} from 'vuex'
import {
    VERIFY_TOKEN
} from '@/store/actions.type'
export default {
    name: 'verify-login',
    data () {
        return {
            tokenError: false
        }
    },
    computed: {
        ...mapGetters([
            'isAuthenticated'
        ])
    },
    mounted () {
        console.log(this.isAuthenticated)
        if ( this.$route.params.token ) {
            this.$store
                .dispatch(
                    VERIFY_TOKEN,
                    this.$route.params.token
                )
                .then((r) => {
                    if ( r.user ) this.$router.push({
                        name: 'missions'
                    }).catch(() => {})
                })
                .catch((r) => {
                    if ( r.data.errors && r.data.errors.token ) {
                        this.tokenError = true
                    }
                })
        }
    },
    methods: {
        navigateToLogin () {
            this.$router.push({
                name: 'login'
            }).catch(() => {})
        }
    }
}
</script>
